/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface UserResponseSingle
 */
export interface UserResponseSingle {
    /**
     * 
     * @type {User}
     * @memberof UserResponseSingle
     */
    data?: User;
}

/**
 * Check if a given object implements the UserResponseSingle interface.
 */
export function instanceOfUserResponseSingle(value: object): value is UserResponseSingle {
    let isInstance = true;

    return isInstance;
}

export function UserResponseSingleFromJSON(json: any): UserResponseSingle {
    return UserResponseSingleFromJSONTyped(json, false);
}

export function UserResponseSingleFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserResponseSingle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UserFromJSON(json['data']),
    };
}

export function UserResponseSingleToJSON(value?: UserResponseSingle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UserToJSON(value.data),
    };
}

